import "./LandingAiBenefits.css";

const BENEFITS = [
  "Onbeperkt aantal gebruikers",
  "Resultaten op verschillende aggregatie niveaus",
  "Geen momentopname maar continu inzicht",
];

function LandingAiBenefits() {
  return (
    <section className="landing-ai">
      <div className="landing-ai__text">
        <h3 className="landing-ai__title">
          Door de toepassing van AI en NLP op survey data toewerken naar betere dienstverlening
        </h3>
        <ul className="landing-ai__list">
          {BENEFITS.map((item) => (
            <li key={item}>
              <img src="/hollow-check.png" alt="" />
              {item}
            </li>
          ))}
        </ul>
      </div>
      <div className="landing-ai__media">
        <img src="/screen-mockup.png" alt="Voorbeeld van ContinuMee AI interface" />
      </div>
    </section>
  );
}

export default LandingAiBenefits;
